export function formatMinutes(minutes: number | null | undefined): string | null {
  if (minutes == null) return null;
  if (minutes < 60) return `${minutes} min`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (m === 0) return `${h} h`;
  return `${h} h ${m} min`;
}

export function totalMinutes(prep: number | null, cook: number | null): number | null {
  if (prep == null && cook == null) return null;
  return (prep ?? 0) + (cook ?? 0);
}

export function joinIngredient({
  amount,
  unit,
  name,
  note,
}: {
  amount?: string;
  unit?: string;
  name: string;
  note?: string;
}): string {
  const head = [amount, unit].filter(Boolean).join(' ');
  const body = head ? `${head} ${name}` : name;
  return note ? `${body} (${note})` : body;
}

// Czech plural for recipe counts: 1 recept / 2–4 recepty / 5+ receptů.
export function recipeCount(n: number): string {
  if (n === 1) return '1 recept';
  if (n >= 2 && n <= 4) return `${n} recepty`;
  return `${n} receptů`;
}
